/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2023-05-24 09:43:39
 * @LastEditors: yusha
 * @LastEditTime: 2025-12-15 17:39:57
 */
export const GNH_BC = 'gnh';
export const HWH_BC = 'hwh';
// export const ZT_BC = 'zhengtian';
export const ZT_BC = 'zt';

const HOSTNAME_BC_ID_MAP = {
  localhost: GNH_BC, // 杭立询主体的BC
  '192.168.110.17': GNH_BC, // 杭立询主体的BC
  '192.168.124.83': GNH_BC, // 杭立询主体的BC
  '127.0.0.1': GNH_BC, // 杭立询主体的BC
//   'tiktok-business-admin.xinsulv.com': '6973924533950480386', // 杭立询主体的BC
//   'tiktok-business-admin.adsurpass.com': '7107430972940992514', // 海外户BC
//   'tiktok-business-admin.newrate.net': '7161356844022169601', // 代理商业务主体的BC
//   'tiktok-business-admin-2.newrate.net': '7229250006648193026', // 代理商业务主体的BC
//   'tiktok-business-admin.xinsulv.cn': '7155780945373593601', // 新速率主体的BC, 内部投手使用
//   'tiktok-business-admin-hwh2.adsurpass.com': '7000338652068904962', // 海外户BC
//   'tiktok-business-admin.test': '6973924533950480386',
  'tiktok-business-admin-gnh.test': GNH_BC,
  "tt-biz-adm-test.xinsulv.com":GNH_BC,
//   'tiktok-business-admin-hwh.test': HWH_BC,
  'tt-biz-adm.newrate.net': GNH_BC,
  'tt-agent-test.xinsulv.com' : GNH_BC,
  'tt-biz-adm.adsurpass.com': HWH_BC,
  'tt-biz-adm-bk-hlx1.newrate.net': '6973924533950480386', // 杭立询主体的BC(查询历史数据使用)
  'tt-biz-adm-bk-hlx2.newrate.net': '7161356844022169601', // 代理商业务主体的BC(查询历史数据使用)
  'tt-sea-adm.newrate.net': HWH_BC,

  /**更新测试 */
//   'tiktok-business-admin-zt.test': ZT_BC,

  /** 新增bc */
  'tt-biz-adm-zt.newrate.net': ZT_BC,
};

const BC_ID_NAME_MAP = {
  '6973924533950480386': 'New Rate Limited(HLX1)',
  '7161356844022169601': 'New Rate Limited(HLX2)',
  '7229250006648193026': 'New Rate Limited(HLX2)-2',
  '7155780945373593601': '新速率&New Rate LLC',
  '7107430972940992514': 'New Rate LLC(HWH)',
  '7000338652068904962': 'New Rate LLC(HWH2)',
  [GNH_BC]: 'New Rate Limited',
  [HWH_BC]: 'New Rate LLC(HWH)',

  /** 测试更新 */
  [ZT_BC]: 'NewRate LLC(ZT)',
};

export function getBcId() {
  return HOSTNAME_BC_ID_MAP[document.location.hostname];
}

export function getBcName() {
  return BC_ID_NAME_MAP[getBcId()];
}

const HWH_BC_IDS = ['7107430972940992514', '7000338652068904962', HWH_BC];

export function isHWH() {
  return HWH_BC_IDS.includes(getBcId());
}
